// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2m4B7","backlabel":"styles_backlabel__2RLKb","header":"styles_header__xSqYD","formContainer":"styles_formContainer__331gA"};